import { isArray } from "jquery";
import {
  LIST_USER_FAILED,
  LIST_USER_REQ,
  LIST_USER_SUCCESS,
} from "../Constants/userConstant";
import axiosConfig from "../Core/axiosConfig";

export const listUsers = () => async (dispatch) => {
  try {
    dispatch({ type: LIST_USER_REQ });
    const { data } = await axiosConfig.get("/users");
    if (!isArray(data?.Result) && data?.Result?.include("Error")) {
      dispatch({ type: LIST_USER_FAILED, payload: data?.Result });
    } else {
      dispatch({
        type: LIST_USER_SUCCESS,
        payload: data?.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: LIST_USER_FAILED,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
